module.exports = __webpack_public_path__ + "static/img/apply.92f81c4b.png";